import React from "react"
import { translate } from "react-i18next"
import PropTypes from "prop-types"
import { AutoSuggest } from "../inputs"
import PersonCardShape from "../../state/shapes/PersonCardShape"

const ManagerFilter = ({
  filter, onChange, itemSelected, placeholder, t,
}) => {
  const itemToString = (item) => {
    return item ? item.name : ""
  }

  let selection = {
    employeeId: -1,
    name: "",
    location: "",
    jobTitle: "",
    statusId: 0,
    statusTranslationIdentifier: "",
  }

  if (itemSelected > 0) {
    selection = filter.find(employee => employee.employeeId === itemSelected)
  }

  return (
    <AutoSuggest
      itemToString={itemToString}
      placeholder={t(placeholder)}
      items={filter}
      onChange={onChange}
      itemSelected={selection}
    />
  )
}

ManagerFilter.propTypes = {
  filter: PropTypes.arrayOf(PropTypes.shape(PersonCardShape)).isRequired,
  itemSelected: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

export default translate()(ManagerFilter)



// WEBPACK FOOTER //
// ./src/components/filters/ManagerFilter.jsx